import styled, { css } from 'styled-components';
import {
  MEDIA_CARD_WIDTH,
  ReactResponsiveCarousel as ReactResponsiveCarouselComponent,
} from 'src/components';
import theme from 'src/utils/theme';

export const CHUNK_SIZE = 2;
const gapsCount = CHUNK_SIZE - 1;
const cardsGap = theme.sz.s5;
const carouselWidth = `calc(${MEDIA_CARD_WIDTH} * ${CHUNK_SIZE} + ${cardsGap} * ${gapsCount})`;

export const Chunk = styled.div(
  ({ theme }) => css`
    width: 100%;
    padding-bottom: ${theme.sz.s1};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    @media (min-width: ${theme.sz.lg}) {
      max-width: ${theme.sz.md};
      margin-left: auto;
      margin-right: auto;
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s4};
    ${theme.typography.paragraph.base};
  `,
);

export const LICBlock = styled.div<{
  $type: 'learn' | 'immerse' | 'communicate';
}>(
  ({ theme, $type }) => css`
    padding-top: ${theme.sz.s8};
    padding-bottom: ${theme.sz.s8};
    color: ${theme.co.secondary10};
    clip-path: inset(0 -100vmax);

    ${
      $type === 'communicate' &&
      css`
        background-color: ${theme.co.information98};
        box-shadow: 0 0 0 100vmax ${theme.co.information98};
      `
    }

    ${
      $type === 'immerse' &&
      css`
        background-color: ${theme.co.error90};
        box-shadow: 0 0 0 100vmax ${theme.co.error90};
      `
    }
    
    ${
      $type === 'learn' &&
      css`
        background-color: ${theme.co.success98};
        box-shadow: 0 0 0 100vmax ${theme.co.success98};
      `
    }
  
    @media (min-width: ${theme.sz.lg}) {
      border-radius: ${theme.bo.medium};
      box-shadow: unset;
      clip-path: unset;
    }
  `,
);

export const ReactResponsiveCarousel = styled(ReactResponsiveCarouselComponent)(
  ({ theme }) => css`
    display: none;

    @media (min-width: ${theme.sz.lg}) {
      display: block;
      width: ${carouselWidth};
      margin-top: ${theme.sz.s6};
      margin-left: auto;
      margin-right: auto;
    }

    @media (min-width: ${theme.sz.xl}) {
      margin-left: unset;
      margin-right: unset;
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.m};

    @media (min-width: ${theme.sz.lg}) {
      ${theme.typography.heading.desktop.m};
    }
  `,
);

export const Scroll = styled.div(
  ({ theme }) => css`
    /* 
    For some reason, it is impossible to use this here.
    It breaks the layout on iOS mobile devices.
    This issue should be investigated and fixed as part of this task:
    https://memrise.atlassian.net/browse/CF-963.
    */
    width: 100vw;
    margin-left: -${theme.sz.s6};
    margin-right: -${theme.sz.s6};
    padding-left: ${theme.sz.s6};
    padding-right: ${theme.sz.s6};
    overflow-x: auto;
    margin-top: ${theme.sz.s6};
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: ${cardsGap};

    @media (min-width: ${theme.sz.lg}) {
      display: none;
    }
  `,
);
